import styled from "styled-components";

interface ButtonProps {
  $isActive: boolean;
}

export const TabItem = styled.button<ButtonProps>`
  border: none;
  background: transparent;
  font-size: 12px;
  color: ${(props) => (props.$isActive ? "#F57C00" : "#6B7280")};
  font-weight: ${(props) => (props.$isActive ? 700 : 500)};
  cursor: pointer;

  svg {
    fill: ${(props) => (props.$isActive ? "#FFA14D" : "#D4D4D4")};
  }
`;
